import '.h{width:100%;}.ssr-plugin'
import '.bt{height:4px;}.ssr-plugin'
import '.a0{position:relative;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.ak{gap:12px;}.ssr-plugin'
import '.bu{align-items:flex-start;}.ssr-plugin'
import '.t{align-self:stretch;}.ssr-plugin'
import '.bv{border-radius:999px;}.ssr-plugin'
import '.bw{opacity:0.15;}.ssr-plugin'
import '.bg{overflow:hidden;}.ssr-plugin'
import '.bx{transition:width 120ms ease-out;}.ssr-plugin'
import '.a2{position:absolute;}.ssr-plugin'
import '.by{left:0px;}.ssr-plugin'
import '.bz{top:0px;}.ssr-plugin'
import '.bh{padding:24px;}.ssr-plugin'
import '.be{position:fixed;}.ssr-plugin'
import '.ab{bottom:0px;}.ssr-plugin'
import '.c0{right:0px;}.ssr-plugin'
import '.x{margin:0 auto;}.ssr-plugin'
import '.bq{max-width:1280px;}.ssr-plugin'
import '.v{justify-content:space-between;}.ssr-plugin'
import '.b{align-items:center;}.ssr-plugin'
import '.c1{gap:48px;}.ssr-plugin'
import '.b9{align-items:start;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import { FC } from 'react'
import { Text } from './Text'
import { Button } from './Button'
import { useTheme } from '../providers/useTheme'
import { Link } from 'wouter'
import { styled } from 'inlines'
import { useAppCtx } from '../providers/useAppCtx'
import { formatCurrency } from '@/apps/cms/utils/misc'
import { useTranslations } from '../hooks/useTranslations'

type CartItemsIndicatorProps = {
  cartItems?: number
  cartItemsMax?: number
  cartItemsMin?: number
  color?: string
}

export const CartItemsIndicator: FC<CartItemsIndicatorProps> = ({
  cartItems = 0,
  cartItemsMax = 0,
  cartItemsMin = 0,
  color = '#FFFFFF',
}) => {
  const ratio =
    cartItemsMax && cartItemsMax > 0 ? Math.min(cartItems / cartItemsMax, 1) : 0

  const widthMinVotesBar = Math.floor((cartItemsMin / cartItemsMax) * 100)
  const diff = cartItemsMax - cartItemsMin

  const ratioForSecondBar =
    cartItems >= cartItemsMin ? ((cartItems - cartItemsMin) / diff) * 100 : 0

  return cartItemsMin && cartItemsMin > 1 ? (
    <div className="h bt a0 a ak"
    >
      {/* minvotes bar */}
      <div className="bt a0"
        style={{
          width: widthMinVotesBar + '%',}}
      >
        <div className="a bt bu t bv bw bg"
          style={{
            background: color,}}
        ></div>
        <div className="bt bv bx a2 by bz"
          style={{
            width:
              cartItems < cartItemsMin
                ? `${(cartItems / cartItemsMin) * 100}%`
                : '100%',
            background: color,}}
        />
      </div>

      {/* second bar */}
      <div className="bt a0"
        style={{
          width: `calc(100% - ${widthMinVotesBar}%`,}}
      >
        <div className="a bt bu t bv bw bg"
          style={{
            background: color,}}
        ></div>
        <div className="bt bv bx a2 by bz"
          style={{
            width: `${ratioForSecondBar}%`,
            background: color,}}
        />
      </div>
    </div>
  ) : (
    <div className="h bt a0"
    >
      <div className="a bt bu t bv bw bg"
        style={{
          background: color,}}
      ></div>
      <div className="bt bv bx a2 by bz"
        style={{
          width: `${ratio * 100}%`,
          background: color,}}
      />
    </div>
  )
}

export const CartBar: FC = () => {
  const { colors } = useTheme()

  const {
    votesCount,
    activeLanguage,
    price,
    currency,
    maxVotes,
    minVotes = 0,
  } = useAppCtx()
  const { data: cartTranslations } = useTranslations('cart')

  const priceLabel = formatCurrency(
    (votesCount * price) / 100,
    currency,
    activeLanguage,
  )

  return (
    <div className="h bh be ab c0 by"
      style={{
        background: colors.primaryAccent,}}
    >
      <div className="x h bq a v b c1"
      >
        <div className="h b9 a i ak"
        >
          <CartItemsIndicator
            cartItems={votesCount}
            cartItemsMax={maxVotes}
            cartItemsMin={minVotes}
            color={colors.background}
          />

          <Text variant="display-regular" color={colors.background}>
            {minVotes && votesCount < minVotes
              ? cartTranslations?.minVotes_indicator
              : `${cartTranslations?.counting_votes_indicator} - ${priceLabel}`}
          </Text>
        </div>

        <Link href="/cart">
          <Button
            isDisabled={minVotes ? votesCount < minVotes : false}
            id="cartbar-link-cart"
            label={cartTranslations?.add_to_cart_button}
            trailIcon="arrow"
            style={{ background: colors.background }}
            color={colors.primaryAccent}
          />
        </Link>
      </div>
    </div>
  )
}
